import React from 'react';
import { useState, useEffect } from 'react';
import '../App.css';
import { Form, Container, Icon, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { storageUtils } from '../utils/localStorage';

export default function Main() {
  const [userEmail, setUserEmail] = useState('');
  const [userName, setUserName] = useState();
  const [userLoggedIn, setuserLoggedIn] = useState(false);
  const [completedItems, setcompletedItems] = useState([]);

  const [showMessage, setShowMessage] = useState();

  // const userEmail = 'dom@test.com';
  let chilliName = 'default';

  const logIn = () => {
    console.log('login', userEmail);
    if (userEmail !== '') {
      storageUtils.setUser(userEmail);

      console.log('---> users name: ', userName);

      storageUtils.setUserName(userName);
      setuserLoggedIn(true);
    }
  };

  const putItemsInLocalStorage = (item) => {
    console.log('!!!! >>>> putItemsInLocalStorage CALLED');

    // Use the utility function to add the item
    const updatedItems = storageUtils.addCompletedItem(item);

    // Update state
    setcompletedItems(updatedItems);

    console.log('Ive updated completed items');
    setTimeout(() => {
      console.log('completedItems update in state... ', completedItems);
      console.log(
        'Current year completed items:',
        storageUtils.getCompletedItems()
      );
    }, 3000);
  };

  const setChilliName = (value) => {
    chilliName = value;
    console.log('chilliname is now', chilliName);
  };
  const listOfChillis = [
    { id: '4', n: 'Mark Parcel', name: "Grammy's Smack Your Lips Chilli" },
    { id: '8', n: 'Stephanie Teeter', name: 'Mean Jean' },
    {
      id: '12',
      n: 'Michael Perrino',
      name: 'Chili While Camping, it’s Intents',
    },
    { id: '16', n: 'Jason Smith', name: 'Wood Pros Chili' },
    // { id: '2', n: 'Jamie Mendoza', name: 'Brown Chicken Brown Cow' },
    { id: '2', n: 'Katie Q', c: 'Quintessential Q Chili' },
    { id: '6', n: "JJ O'Connor", name: 'Jack in the Pot' },
    { id: '10', n: 'Vanessa Hastings', name: 'The Canadian' },
    { id: '14', n: 'Jourdan O’Connor', name: 'Minute To Win It' },
    { id: '1', n: 'Bill Meyers', name: "Billi's Chilli" },
    { id: '5', n: 'Katie Roeder', name: 'Ham Bam Thank You Yam!' },
    { id: '9', n: 'Matt Shepherd', name: 'Mom and Pop’s' },
    { id: '13', n: 'Natalie Lavalee', name: 'Slow Burn' },
    { id: '3', n: 'Orlando', name: 'Chilling Me Softly' },
    { id: '7', n: 'Joey Calzante', name: 'Leave The Gun, Take The Chili' },
    { id: '11', n: 'Franco Calzante', name: 'Not your Abuelas Chili' },
    { id: '15', n: 'Bob Roybal', name: 'Uncle Baby Birdee’s Bayou Batch' },
  ];
  //#4	Mark Parcel	Grammy's Smack Your Lips Chilli
  // #8	Stephanie Teeter	Mean Jean
  // #12	Michael Perrino	Oppenheimer's A-Bomb 2.0
  // #16	Jason Smith	Wood Pros Chili
  // #2	Jamie Mendoza	Brown Chicken Brown Cow
  // #6	JJ O'Connor	Jack in the Pot
  // #10	Vanessa Hastings	The Candian
  // #14	Tim Meyers	Straight Outta Flavortown
  // #1	Bill Meyers	Billi's Chilli
  // #5	Katie Roeder	Ham Bam Thank You Yam!
  // #9	Matt Shepherd	Mom and Pop’s
  // #13	Natalie Lavalee	Slow Burn
  // #3	Orlando	Chilling Me Softly
  // #7	Joey Calzante	Leave The Gun, Take The Chili
  // #11	Franco Calzante	Not your Abuelas Chili
  // #15	Bob Roybal	Uncle Baby Birdee’s Bayou Batch

  // all old
  // const listOfChillis = [
  //   { id: '1', n: "JD Englum's Chilli", name: 'All Day Chili' },
  //   { id: '2', n: "Dave Douglas's Chilli", name: 'Sweet Heat' },
  //   { id: '3', n: "Katie Quebbeman's Chilli", name: 'Straight from the Can' },
  //   { id: '4', n: "Pete & Aimee B's Chilli", name: "Don't Fear the Reaper" },
  //   { id: '5', n: "Steve & Debbie H's Chilli", name: 'Hell Hath No Fury' },
  //   { id: '6', n: "Jason Smith's Chilli", name: 'The Bartlett Banger' },
  //   { id: '7', n: "Deanna Thunberg's Chilli", name: 'Borracha Picante' },
  //   {
  //     id: '8',
  //     n: "Jourdan Thunberg's Chilli",
  //     name: "Good 'Til the Last Drop",
  //   },
  //   { id: '9', n: "Don Thunberg's Chilli", name: "Better Than My Wife's" },
  //   {
  //     id: '10',
  //     n: "Brody Roybal's Chilli",
  //     name: 'The Brody Roybal Experience',
  //   },
  //   { id: '11', n: "JJ O'Connor's Chilli", name: "Sweet Baby J's" },
  //   { id: '12', n: "Bob Roybal's Chilli", name: "Can't Beat My Meat" },
  //   { id: '13', n: "Matt Shepherd's Chilli", name: "Ma and Pa's 2.0" },
  //   { id: '14', n: "Bill Meyers's Chilli", name: 'Notorious P.I.G.' },
  //   { id: '15', n: "Becky & Roy C's Chilli", name: 'Sassy Sauce' },
  //   {
  //     id: '16',
  //     n: "Ron & Char Hall's Chilli",
  //     name: 'Stick to the Ribs Chili',
  //   },
  // ];

  const signUserOut = () => {
    console.log('signUserOut');
    setUserName(undefined);
    setUserEmail('');
    setcompletedItems([]); // Clear state

    // Clear user data but leave completed items (they're year-specific now)
    storageUtils.clearUser();

    setuserLoggedIn(false);
    setShowMessage('logout');
  };

  useEffect(() => {
    console.log('useEffect');
    const user = storageUtils.getUser();
    const userName = storageUtils.getUserName();

    if (user) {
      console.log('email is here in local storage');
      setUserEmail(user);

      if (userName) {
        setUserName(userName);
      }

      setuserLoggedIn(true);
    }

    // Get completed items for current year
    const completedItemsForYear = storageUtils.getCompletedItems();
    if (completedItemsForYear.length > 0) {
      console.log(
        `USE EFFECT: This user has voted for items in ${storageUtils.getCurrentYear()}. Setting state`
      );
      setcompletedItems(completedItemsForYear);

      setTimeout(() => {
        console.log(
          'USE EFFECT: completedItems update in state... ',
          completedItemsForYear
        );
      }, 3000);
    }

    console.log(
      `completedItems for ${storageUtils.getCurrentYear()} >>`,
      completedItemsForYear
    );

    const query = new URLSearchParams(window.location.search);
    console.log('url parameters', query);
    console.log(`window.location.search ${window.location.search}`);
    const completed = query.get('completed');
    console.log('completed url parameter: ', completed);

    if (completed) {
      console.log('there is an chili id in completed.', completed);
      putItemsInLocalStorage(completed);
    }

    const userEmailWhoCompletedGrading = query.get('ue');
    console.log(`userEmailWhoCompletedGrading ${userEmailWhoCompletedGrading}`);

    const signout = query.get('signout');
    if (signout === 'true') {
      console.log('there is a parameter in the URL to log out.');
      signUserOut();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <header className="App-header">
      <div className="content">
        <div className="top-half"></div>

        <div style={{ height: '30px', padding: 0 }}>
          <img
            src="hot-pepper.png"
            alt="Hot pepper icon"
            style={{
              height: '90px',
              backgroundColor: 'white',
              position: 'relative',
              top: '-48px',
              padding: 20,
              borderRadius: 60,
            }}
          ></img>
        </div>

        <div className="text-container">
          <h4 className="custom-fonts" style={{ marginTop: 20 }}>
            Welcome to JJ's Chili Cookoff!
          </h4>

          <p style={{ fontSize: 18, paddingBottom: 100 }}>
            Please scan the QR code to get access to your tasting group!
          </p>
        </div>
        {false && (
          <div>
            {!userLoggedIn && (
              <div className="login-container">
                <p style={{ fontSize: 17, marginBottom: 20 }}>
                  Tasters, enter your email to get started.
                </p>

                <Container textAlign="left" className="login-form-container">
                  <Form>
                    <Form.Field>
                      <label>Full Name</label>
                      <input
                        placeholder="Full Name"
                        onChange={(event) => setUserName(event.target.value)}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Email</label>
                      <input
                        placeholder="BiebsWasHere@gmail.com"
                        onChange={(event) => setUserEmail(event.target.value)}
                      />
                    </Form.Field>

                    <Container textAlign="center" style={{ marginTop: 25 }}>
                      <button className="email-btn" onClick={logIn}>
                        Start
                      </button>
                    </Container>
                    {/* <Button type='submit'>Submit</Button> */}
                  </Form>
                </Container>
              </div>
            )}

            {userLoggedIn && (
              <div>
                <div className="chili-listing-container">
                  <ul className="chilli-listings">
                    {listOfChillis.map(function (item, id) {
                      return (
                        <li className="chilli-listing-item" key={item.id}>
                          <div className="ui grid" style={{ height: 70 }}>
                            {/* ICON */}
                            <div
                              style={{ Top: 20 }}
                              className="two wide column"
                            >
                              {completedItems.includes(item.id) ? (
                                <img
                                  src="pot-icon-done.png"
                                  alt="Completed pot icon"
                                  style={{ height: 35, marginRight: 10 }}
                                ></img>
                              ) : (
                                <img
                                  src="pot-icon.png"
                                  alt="Pot icon"
                                  style={{ height: 35, marginRight: 10 }}
                                ></img>
                              )}
                              <span
                                style={{
                                  fontSize: 20,
                                  position: 'relative',
                                  left: 12,
                                  top: -25,
                                  color: 'white',
                                }}
                              >
                                {item.id}
                              </span>
                            </div>

                            {/* TEXT */}
                            <div
                              style={{ paddingTop: 25 }}
                              className="fourteen wide column"
                            >
                              <a
                                className="chili-link"
                                style={
                                  item.name.length > 24
                                    ? { fontSize: '16px' }
                                    : {}
                                }
                                onClick={() => {
                                  setChilliName(item.name);
                                }}
                                href={
                                  'https://form.typeform.com/to/NwRvOUFm#chilliname=' +
                                  item.name +
                                  '&chilliid=' +
                                  item.id +
                                  '&useremail=' +
                                  userEmail +
                                  '&username=' +
                                  userName
                                }
                              >
                                {item.name}
                                {completedItems.includes(item.id) && (
                                  <span style={{ paddingLeft: 8 }}>✅</span>
                                )}
                              </a>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>

                {userEmail && (
                  <em style={{ fontSize: '9px', color: 'grey' }}>
                    Logged in as {userName} ({userEmail})
                  </em>
                )}
                {/* <span>{completedItems}</span> */}
              </div>
            )}
          </div>
        )}

        {showMessage === 'logout' && (
          <Message color="blue">
            {/* <p style={{ fontSize: 13 }}> */}
            Logged out. Please log back in with the same email you used last
            time
            {/* </p> */}
          </Message>
        )}

        <Container textAlign="right">
          <Link to="/settings">
            <Icon
              name="setting"
              size="small"
              style={{
                color: '#dbdbdb',
                position: 'relative',
                right: 10,
                bottom: 10,
              }}
            />
          </Link>
        </Container>
      </div>
    </header>
  );
}
